<template>
	<div class="maintaince">
		<div class="maintaince-left">
			<div class="image-center">
				<img src="@/assets/images/maintaince/Group3289.png" alt="">
			</div>
			<div class="image-logo">
				<img src="@/assets/images/maintaince/Group.png" alt="">
			</div>
		</div>
		<div class="maintaince-right">
			<div class="center-content">
				<div class="icon">
					<img src="@/assets/images/maintaince/info-circle.svg" alt="">
				</div>
				<div class="m-t-15">
					<h1>Maintenance Notice</h1>
					<h3>Time: 10AM - 14PM (GMT +7) Oct 28, 2019 </h3>

					<p>
						We are now updating a brand new version of Sales Box to improve overall app performance and enhance some features. 
					</p>

					<p>
						In the meantime, you can't access app Dashboard and offer boxes will be temporarily hidden on your storefront. 
					</p>

					<p>
						Please be patient and come back few hours later. We appreciate your understanding as Sales Box is working hard to improve your app experience. 
					</p>

					<p>
						All the best and see you soon,
					</p>
					<p>
						- Sales Box Team -
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name : 'Main'
}
</script>
<style lang="scss" scoped>
	.maintaince{
		background: #fff;
		height: 100vh;
		width: 100%;
		display: flex;
		flex-direction: row;
		&-left{
			background-image: url("../../assets/images/login/login-background.svg");
			background-size: cover;
			background-position: bottom center;
			background-repeat: no-repeat;
			@include flex(50%);
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			padding: 0 0 50px 0;
			.image-center{
				width: 440px;
				img{
					max-width: 100%;
					max-height: 100%;
				}
			}
			

			.image-logo{
				position: absolute;
				bottom: 60px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
		&-right{
			@include flex(50%);
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			padding: 50px 0;
			.center-content{
				width: 460px;
				.icon{
					width: 35px;
					height: 35px;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					background-color:  rgba(25, 176, 84, 0.2);
					border-radius: 50%;
					overflow: hidden;
				}
				h1{
					font-weight: bold;
					font-size: 29px;
					color:$primary;
					margin: 0;
				}
				h3{
					font-size: 18px;
					color:$primary;
					margin: 5px 0 20px 0;
				}
				p{
					font-size: 14px;
					margin: 15px 0 0 0;
				}
			}
		}
	}
	@media(max-width:1400px){
		.maintaince{
			&-left{
				.image-center{
					width: 50%;
				}
				

				.image-logo{

				}
			}
			&-right{
				@include flex(50%)
			}
		}
	}
</style>